import styled from 'styled-components'

import { Color } from 'root-constants'

export const StyledCarouselSkeleton = {
  Wrapper: styled.div`
    display: flex;
    flex-direction: column;
  `,
  Dots: styled.div`
    height: 28px;

    display: flex;
    align-items: flex-end;
    justify-content: center;
    gap: 8px;
  `,
  Dot: styled.span`
    width: 8px;
    height: 8px;

    border-radius: 50%;
    background: ${Color.SKY_BASE};

    &:first-child {
      background: ${Color.GOLD_BASE};
    }
  `,
}
